import Vue from 'vue';
import ImageViewer from '../../components/ImageViewer.vue';

// 创建一个图片预览工具类
class ImageViewerUtil {
  constructor() {
    this.viewerInstance = null;
  }

  // 打开图片预览
  open (imageUrl) {
    if (!imageUrl) {
      console.error('图片地址不能为空');
      return;
    }

    // 如果实例已存在，则销毁它
    if (this.viewerInstance) {
      this.viewerInstance.$destroy();
      document.body.removeChild(this.viewerInstance.$el);
    }

    // 创建组件实例
    const ViewerConstructor = Vue.extend(ImageViewer);
    this.viewerInstance = new ViewerConstructor({
      propsData: {
        imageUrl
      }
    });

    // 挂载实例并添加到DOM
    this.viewerInstance.$mount();
    document.body.appendChild(this.viewerInstance.$el);

    // 打开预览
    setTimeout(() => {
      this.viewerInstance.openViewer();
    }, 100);
  }
}

// 导出单例
export default new ImageViewerUtil();  